import React from 'react'
import { Accordion, AccordionWrapper } from '../seo-content/seo_content';
import styled from 'styled-components';

type Props = {}

const BetdailySEO = (props) => {
    return (
        <>
            <AccordionWrapper>
                <Accordion>
                    <input type="checkbox" id="section1" className="accordion__input" />
                    <label htmlFor="section1" className="accordion__label"><h1>PSL POINTSTABLE</h1></label>
                    <div className="accordion__content">

                        <h2>PSL Points Table on BetDaily</h2>
                        PSL Points Table provides real-time updates for Pakistan Super League cricket matches. It allows
                        users to follow the action as it unfolds. Are you looking for the PSL Points Table, along with all
                        the details required for PSL Betting?
                        If so, you’ve found the right place. PSL Points Table is a great resource for cricket fans of all
                        levels, from those just starting to seasoned veterans. Plus, it's a great way to stay up-to-date on the
                        latest PSL live matches and developments.
                        The Pakistan Super League (PSL) is a cricket tournament that brings together the best players from
                        all over the country in a thrilling display of athleticism and skill. The league has become one of
                        the most popular cricket tournaments in the world, drawing in millions of fans from all over the
                        globe. If you're looking to understand the PSL better and all it has to offer, then this definitive
                        guide is just what you need.
                        Here, you'll find all the information you need on teams, players, fixtures, PSL points table, and
                        more to keep up with the action and never miss a beat. Whether you're a die-hard fan or a casual
                        observer, this guide has something for everyone. So, let's dive into the Pakistan Super League's
                        exciting world and explore all it offers!

                        <h2> History of Pakistan Super League | Points Table Legacy</h2>
                        The Pakistan Cricket Board founded the Pakistan Super League (PSL) in 2015 with five teams. In
                        2016, the PSL's first season was played, with five teams representing different cities in Pakistan.
                        The PSL teams were Quetta Gladiators, Lahore Qalandars, Peshawar Zalmi, Islamabad United,
                        and Karachi Kings. Due to Pakistan's ban on cricket, the inaugural season was played exclusively
                        in the United Arab Emirates. Islamabad United emerged as the champions by defeating Quetta
                        Gladiators in the final.
                        The second season was held in 2017, with the addition of one more team, Multan Sultans. The
                        tournament was played in the UAE and Pakistan, with the final in Lahore. Peshawar Zalmi won
                        the championship by defeating Quetta Gladiators in the final.


                        The third season of the PSL was held in 2018, with all matches played in Pakistan, except the final,
                        which was held in Karachi. Islamabad United won the tournament for the second time by defeating
                        Peshawar Zalmi in the final and they topped the PSL Points Table.
                        The fourth season of the PSL was held in 2019, with the addition of a team named the Sultans.
                        The tournament was played in the UAE and Pakistan, with the final in Karachi. Quetta Gladiators
                        won the championship for the first time by defeating Peshawar Zalmi in the final.
                        The fifth season of the PSL was held in 2020, with all matches played in Pakistan. Karachi Kings
                        won the tournament for the first time by defeating Lahore Qalandars in the final.
                        The sixth season of the PSL was held in 2021 in United Arab Emirates between Multan Sultans
                        and Peshawar Zalmi; Multan Sultans won the 2021 PSL victory. Notably, Multans are on top,
                        when it comes to PSL Points Table in the recent years. If their form continues, they can pose a
                        threat to all the other teams this year.
                        The seventh season of the PSL was held in 2022, where Lahore Qalandars won by defeating
                        Multan Sultans by 42 runs.
                        Millions of viewers tune in to watch the PSL every year, making it one of the most watched cricket
                        competitions in the world. The PSL has a huge fan base, not just in Pakistan but all over the world.



                        <h2> PSL Teams & Players List</h2>
                        The Pakistan Super League (PSL) comprises six franchises: Islamabad United, Karachi Kings,
                        Lahore Qalandars, Peshawar Zalmi, Quetta Gladiators, and Multan Sultans. Each team comprises
                        some of the best players from all over the country, giving fans an exciting display of cricket talent
                        and a tough competition on the PSL Points Table.
                        <h3> Islamabad United</h3>
                        Islamabad United is one of the six franchise teams that compete in the Pakistan Super League
                        (PSL). The team has won the PSL title twice, in 2016 and 2018, making them one of the most
                        successful teams in the league. The team is known for its strong all-round performance and
                        balanced mix of local and international players.
                        Some notable players representing Islamabad United include Abrar Ahmed, Alex Hales,
                        Rahmanullah Gurbaz, Colin Munro, Paul Stirling, Azam Khan, Rumman Raees, Moeen Ali,
                        Sohaib Maqsood, Mubasir Khan, Hassan Nawaz, Zeeshan Zamir, Asif Ali, Shadab Khan, Fazal
                        Haq Farooqi, Wasim Jr, Faheem Ashraf, Hasan Ali. Shadab Khan, a talented all-rounder and a
                        regular Pakistan national cricket team member, has captained the team.

                        <h3> Karachi Kings</h3>
                        Karachi Kings is one of the popular teams the Pakistan Super League (PSL). Karachi Kings won
                        the PSL title once in 2020, making them one of the most successful PSL teams in the league. The
                        team is known for its strong batting lineup, including some of the top T20 players from Pakistan
                        and worldwide.
                        The key players of Karachi Kings include Imad Wasim (Captain), Shoaib Malik, Haider Ali,
                        Mohammad Amir, Qasim Akram, Tabraiz Shamsi, Andrew Tye, Mir Hamza, Aamer Yamin,
                        Sharjeel Khan, Matthew Wade, Imran Tahir, James Fuller, Tayyab Tahir, James Vince,
                        Muhammad Akhlaq, Irfan Khan, Mohammad Umar.
                        <h3> Lahore Qalandars</h3>
                        Lahore Qalandars has won a PSL title in the seventh edition of PSL; also, they have made it to the
                        playoffs in three seasons. This PSL team is known for its strong young talent, focusing on
                        developing local players from the grassroots level.
                        Shaheen Afridi (Captain), Harry Brook, Kamran Ghulam, Shawaiz Irfan, Hussain Talat, Sikandar
                        Raza, Haris Rauf, Ahmed Daniyal, Liam Dawson, Dilbar Hussain, Rashid Khan, David Wiese,
                        Abdullah Shafique, Zaman Khan, Fakhar Zaman, Mirza Tahir Baig, Jordan Cox and Jalat Khan
                        are the top players of LQ.
                        <h3> Peshawar Zalmi</h3>
                        Peshawar Zalmi has won the PSL title once in 2017 and has consistently performed in the league,
                        making it to the playoffs each season. The team is known for its strong all-round performance and
                        balanced mix of local and international players.
                        Squad: Babar Azam (Captain), Wahab Riaz, Aamer Jamal, Tom Kohler-Cadmore, Salman Irshad,
                        Sherfane Rutherford, Ur Rahman, Mohammad Haris, Bhanuka Rajapaksa, Sufiyan Muqeem,
                        Haseebullah Khan, Rovman Powell, Mujeeb Danish Aziz, Arshad Iqbal, Saim Ayub and Jimmy
                        Neesham.


                        <h3> Quetta Gladiators</h3>
                        Quetta Gladiators has won the PSL title once in 2019 and has been a consistent performer in the
                        league, making it to the playoffs each season. The team is known for its strong batting lineup, with
                        a focus on big-hitting overseas players.
                        Roster: Sarfaraz Ahmed (Captain), Wanindu Hasaranga, Jason Roy, Odean Smith, Ahsan Al,
                        Mohammad Nawaz, Iftikhar Ahmed, Naveen-ul-Haq, Will Smeed, Mohammad Hasnain, Umar

                        Akmal, Mohammad Zahid, Abdul Wahid Bangalzai, Aimal Khan, Martin Guptill, Naseem Shah,
                        Umaid Asif, Omair Yousuf.
                        <h3> Multan Sultans</h3>
                        Multan Sultans won only one PSL title in 2021, and they have been a competitive team in the
                        league, making it to the playoffs in their debut season. This PSL team is known for its strong allround performance, with a focus on developing young talent from the local region.
                        Multan Sultans Team: Mohammad Rizwan (Captain), David Miller, Rilee Rossouw, Usman Khan,
                        Sameen Gul, Shan Masood, Anwar Ali, Mohammad Sarwar, Shahnawaz Dahani, Khushdil Shah,
                        Ihsanullah, Josh Little, Tim David, Abbas Afridi, Akeal Hosein, Usama Mir, Adil Rashid, Arafat
                        Minhas.
                        <h2> PSL Winners List</h2>
                        Before we move on to look at the PSL Points Table, have a look at the PSL Winners List from
                        2016 through 2022:

                        Year Winner Runners Up
                        2016 Islamabad United Quetta Gladiators
                        2017 Peshawar Zalmi Quetta Gladiators
                        2018 Islamabad United Peshawar Zalmi
                        2019 Quetta Gladiators Peshawar Zalmi
                        2020 Karachi Kings Lahore Qalandars
                        2021 Multan Sultans Peshawar Zalmi
                        2022 Lahore Qalandars Multan Sultans
                        <h2> PSL Live Score: Stay Up-to-Date Always</h2>\
                        The PSL live score refers to the real-time updates of the scores and statistics of the matches played
                        in the Pakistan Super League (PSL). The league is organized annually, and



                        Pakistan Super League Live Score include:
                        ● The score, overs completed, wickets lost, and run rate are all shown.
                        ● Statistics for bowling & batting: Details about each batsman's and bowler's performance,
                        including runs scored, balls faced, and wickets taken.
                        ● Information about the two batsmen's current partnership and the total runs they have scored
                        together.
                        ● The number of wickets lost by each side and the players out of the PSL live match.
                        ● The total amount of additional points each side has given up includes byes, leg-byes, wides,
                        and no-balls.
                        ● Live commentary on the action gives context to the score updates and insight into the PSL
                        live match.
                        ● Graphics, charts, and other visual representations of the score, run rate, and statistical data
                        help to follow the action and comprehend the game.

                        <h2> PSL Points Table</h2>
                        The PSL points table is a standings table that shows the current rankings of the six teams competing
                        in the Pakistan Super League (PSL). The points table is updated after each match and reflects the
                        performance of each team in the tournament.
                        In the PSL, each team plays ten matches in the league stage of the tournament. A team earns two
                        points for a win, one point for a tie or no result, and zero points for a loss. The teams are ranked in
                        the point table based on the number of points earned. If two or more teams have the same number
                        of points, the net run rate (NRR) is used to determine the rankings.
                        The team at the top of the point table at the end of the league stage qualifies directly for the final,
                        while the teams ranked second and third play an eliminator match, and the winner of that match
                        goes on to play the team that finished at the top of the table in the final.
                        The PSL point table indicates a team's chances of progressing to the playoffs and winning the
                        championship. Fans can keep track of the point table to stay updated on their favorite team's
                        position in the tournament. Have a look at the past five years’ PSL point table.
                        <h3> PSL Points Table | 2022</h3>
                        You can get the complete Points Table for this year’s PSL here on BetDaily. Along with that, we
                        have listed the points table of the last 5 editions of PSL.


                        Here is the final Points Table of the Pakistan Super League (PSL) 2022 tournament.

                        <Table>
                            <tr>
                                <th>teams</th>
                                <th>matches</th>
                                <th>won</th>
                                <th>points</th>
                                <th>nrr</th>
                            </tr>
                            <tr>
                                <td>Multan Sultans</td>
                                <td>10</td>
                                <td>9</td>
                                <td>18</td>
                                <td>1.253</td>
                            </tr>
                            <tr>
                                <td>Lahore Qalandars</td>
                                <td>10</td>
                                <td>6</td>
                                <td>12</td>
                                <td>0.765</td>
                            </tr>
                            <tr>
                                <td>Peshawar Zalmi</td>
                                <td>10</td>
                                <td>5</td>
                                <td>10</td>
                                <td>-0.34</td>
                            </tr>

                            <tr>
                                <td>Islamabad United</td>
                                <td>10</td>
                                <td>4</td>
                                <td>8</td>
                                <td>-0.069</td>
                            </tr>
                            <tr>
                                <td>Quetta Gladiators</td>
                                <td>10</td>
                                <td>4</td>
                                <td>8</td>
                                <td>-0.708</td>
                            </tr>
                            <tr>
                                <td>Karachi Kings</td>
                                <td>10</td>
                                <td>1</td>
                                <td>2</td>
                                <td>-0.891</td>
                            </tr>
                        </Table>

                        <h3> PSL Points Table | 2021</h3>
                        Final Points Table of the Pakistan Super League (PSL) 2021 tournament:

                        <Table>
                            <tr>
                                <th>teams</th>
                                <th>matches</th>
                                <th>won</th>
                                <th>points</th>
                                <th>nrr</th>
                            </tr>
                            <tr>
                                <td>Islamabad United</td>
                                <td>10</td>
                                <td>8</td>
                                <td>16</td>
                                <td>0.859</td>
                            </tr>
                            <tr>
                                <td>Multan Sultans</td>
                                <td>10</td>
                                <td>5</td>
                                <td>10</td>
                                <td>1.05</td>
                            </tr>
                            <tr>
                                <td>Peshawar Zalmi</td>
                                <td>10</td>
                                <td>5</td>
                                <td>10</td>
                                <td>0.586</td>
                            </tr>
                            <tr>
                                <td>Karachi Kings</td>
                                <td>10</td>
                                <td>5</td>
                                <td>10</td>
                                <td>-0.115</td>
                            </tr>


                            <tr>
                                <td>Quetta Gladiators</td>
                                <td>10</td>
                                <td>5</td>
                                <td>10</td>
                                <td>-0.589</td>
                            </tr>
                            <tr>
                                <td>Quetta Gladiators</td>
                                <td>10</td>
                                <td>2</td>
                                <td>4</td>
                                <td>-1.786</td>
                            </tr>
                        </Table>

                        <h3> PSL Points Table | 2020</h3>
                        Final Points Table of the Pakistan Super League (PSL) 2020 tournament:
                        <Table>
                            <tr>
                                <th>teams</th>
                                <th>matches</th>
                                <th>won</th>
                                <th>points</th>
                                <th>nrr</th>
                            </tr>
                            <tr>
                                <td>Multan Sultans</td>
                                <td>10</td>
                                <td>6</td>
                                <td>14</td>
                                <td>1.031</td>
                            </tr>
                            <tr>
                                <td>karachi kings</td>
                                <td>10</td>
                                <td>5</td>
                                <td>11</td>
                                <td>-0.19</td>
                            </tr>
                            <tr>
                                <td>Lahore Qalandars</td>
                                <td>10</td>
                                <td>5</td>
                                <td>10</td>
                                <td>-0.072</td>
                            </tr>

                            <tr>
                                <td>Peshawar Zalmi</td>
                                <td>10</td>
                                <td>4</td>
                                <td>9</td>
                                <td>-0.055</td>
                            </tr>
                            <tr>
                                <td>quetta Gladiators</td>
                                <td>10</td>
                                <td>4</td>
                                <td>9</td>
                                <td>-0.772</td>
                            </tr>

                            <tr>
                                <td>Islamabad united</td>
                                <td>10</td>
                                <td>3</td>
                                <td>7</td>
                                <td>0.185</td>
                            </tr>
                        </Table>

                        <h3> PSL Points Table | 2019</h3>
                        Final Points Table of the Pakistan Super League (PSL) 2019 tournament:

                        <Table>
                            <tr>
                                <th>teams</th>
                                <th>matches</th>
                                <th>won</th>
                                <th>points</th>
                                <th>nrr</th>
                            </tr>
                            <tr>
                                <td>Islamabad united</td>
                                <td>10</td>
                                <td>4</td>
                                <td>9</td>
                                <td>-0.772</td>
                            </tr>
                            <tr>
                                <td>karachi kings</td>
                                <td>10</td>
                                <td>5</td>
                                <td>11</td>
                                <td>-0.19</td>
                            </tr>
                            <tr>
                                <td>Peshawar Zalmi</td>
                                <td>10</td>
                                <td>5</td>
                                <td>10</td>
                                <td>-0.072</td>
                            </tr>

                            <tr>
                                <td> Lahore Qalandars</td>
                                <td>10</td>
                                <td>4</td>
                                <td>9</td>
                                <td>-0.055</td>
                            </tr>
                            <tr>
                                <td>quetta Gladiators</td>
                                <td>10</td>
                                <td>4</td>
                                <td>9</td>
                                <td>-0.772</td>
                            </tr>

                            <tr>
                                <td>Lahore Qalandars</td>
                                <td>10</td>
                                <td>3</td>
                                <td>7</td>
                                <td>0.185</td>
                            </tr>
                        </Table>


                        <h2> Stats, Records, and Achievements | Beyond the PSL Points Table</h2>
                        The PSL has seen some incredible records and achievements in its short history. The league has
                        seen some of the most exciting matches in the game's history, with some of the biggest names in
                        cricket participating in the tournament. Some teams might not have ruled the PSL Points Table,
                        but they have made remarkable records.
                        In the 2021 season, Islamabad United United has a 247/2 record against Peshawar Zalmi. That is
                        the most innings ever played in the tournament. For the biggest win in the league, Multan Sultans
                        currently hold the record. In the 2021 and 2022 seasons, they defeated Quetta Gladiators by 110
                        and 117 scores, respectively.
                        Also, live cricket PSL has seen amazing performances, with players worldwide showcasing their
                        skills. Babar Azam holds the record for most runs in the tournament with 2509 runs, while
                        Peshawar Zalmi’s Wahab Riaz holds the record for most wickets with 105 wickets. Look at the
                        top five players with the most runs and wickets in PSL.
                        <h3> Most Runs in PSL</h3>
                        The most runs scored in the Pakistan Super League (PSL) history is by Babar Azam, a Pakistani
                        batsman who plays for the Peshawar Zalmi franchise. Azam has scored a total of 2413 runs in 66
                        matches, with a strike rate of 121.13. Look at the top players with the most runs in the PSL history
                        mentioned

                        <Table>
                            <thead>
                                <tr>
                                    <th>Player</th>
                                    <th>Innings</th>
                                    <th>Runs</th>
                                    <th>50s/100s</th>
                                    <th>Strike Rat</th>

                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>Babar azam</td>
                                    <td>66</td>
                                    <td>2413</td>
                                    <td>23/0</td>
                                    <td>121.13</td>
                                </tr>
                                <tr>
                                    <td>kamran akmal</td>
                                    <td>74</td>
                                    <td>1972</td>
                                    <td>12/3</td>
                                    <td>136.3</td>

                                </tr>
                                <tr>
                                    <td>fakhar zaman</td>
                                    <td>63</td>
                                    <td>1939</td>
                                    <td>16/0</td>
                                    <td>138</td>

                                </tr>
                                <tr>
                                    <td>Shoaib Malik</td>
                                    <td>68</td>
                                    <td>2413</td>
                                    <td>12/0</td>
                                    <td>129.2</td>
                                </tr>
                                <tr>
                                    <td>Mohammad Hafeez</td>
                                    <td>68</td>
                                    <td>1526</td>
                                    <td>12/0</td>
                                    <td>122.13</td>
                                </tr>
                            </tbody>
                        </Table>



                        <h3> Most Wickets in PSL</h3>
                        The most wickets taken in the history of the Pakistan Super League (PSL) is by Wahab Riaz, a
                        left-arm fast bowler who plays for the Peshawar Zalmi franchise. Riaz has taken 103 wickets in
                        76 matches, with an economy rate of 7.59. Look at the top players with the most wickets in the
                        PSL

                        <Table>
                            <thead>
                                <tr>
                                    <th>Player</th>
                                    <th>Innings</th>
                                    <th>Wkt</th>
                                    <th>maidens</th>
                                    <th>economy</th>

                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>Wahab Riaz</td>
                                    <td>76</td>
                                    <td>103</td>
                                    <td>3</td>
                                    <td>7.59</td>
                                </tr>
                                <tr>
                                    <td>hasan ali</td>
                                    <td>63</td>
                                    <td>81</td>
                                    <td>1</td>
                                    <td>7.83</td>

                                </tr>
                                <tr>
                                    <td>Shaheen Shah Afridi</td>
                                    <td>50</td>
                                    <td>70</td>
                                    <td>3</td>
                                    <td>7.63</td>

                                </tr>
                                <tr>
                                    <td>Shadab Khan</td>
                                    <td>60</td>
                                    <td>65</td>
                                    <td>0</td>
                                    <td>7.26</td>

                                </tr>
                                <tr>
                                    <td>Faheem Ashraf</td>
                                    <td>49</td>
                                    <td>64</td>
                                    <td>1</td>
                                    <td>7.94</td>
                                </tr>
                            </tbody>
                        </Table>
                        <h2> Gambling on the Go: Guide to PSL Betting</h2>
                        With the rise of mobile technology and betting apps, betting on the Pakistan Super League has
                        never been easier or more convenient. Keep reading to get all the information you need to start
                        gambling on the go. Whether you’re a novice or a seasoned pro, you’ll find all the knowledge and
                        tips you need here to start betting on the PSL. So, grab your smartphone and get ready to join the
                        excitement of the PSL and reap the rewards of a successful bet.
                        <h3> Popular PSL Satta Betting Markets</h3>

                        The Pakistan Super League offers plenty of betting markets for sports fans. The most popular
                        markets include match betting, top batter, top bowler, and highest opening partnership. Top
                        batsman and top bowler markets allow players to bet on which player will score the most runs or
                        take the most wickets in a PSL live match. The highest opening partnership market allows players
                        to bet on which two players will score the most runs in the opening partnership.
                        Everything starts with the PSL Points Table as the winners make their way to the top. In addition
                        to these popular markets, several special markets are available for the PSL. These include most
                        sixes, fours, dot balls, and run outs. Most sixes and fours markets allow players to bet on which
                        player will hit the most sixes or fours in a match. Most dot balls and run outs markets allow players
                        to bet which team will have the most dot balls or run outs in a match.
                        <h3> Tips for Successful PSL Betting</h3>
                        If you want to be successful in betting on the PSL, you should keep a few tips in mind. First, it’s
                        important to do your research. Researching the teams, players, and match-ups can help you make
                        more informed decisions when placing your bets.
                        It’s also essential to stay up to date on the latest news and odds. Get to know the present standings
                        of each team through the PSL Points Table. Pay attention to the latest news about the teams,
                        players, and matches to make informed decisions. Also, make sure to check the odds regularly to
                        see if there are any changes or if there are any opportunities to take advantage of.
                        Finally, stay disciplined when it comes to betting. Set a budget and stick to it. Don’t be tempted to
                        bet more than you can afford to lose, and don’t chase losses. Betting should be seen as
                        entertainment, not a way to make money.
                        <h3> PSL Satta Strategies</h3>
                        Many betting strategies can be employed when betting on the PSL. One of the most common
                        strategies is to bet on the favourites. The favourites are usually the teams with the best odds, so
                        betting on them can be a good way to win and make money. However, it’s important to remember
                        that there is no guarantee that the favourites will win, so it’s important to research and ensure
                        you’re betting on the team with the best chances of winning.
                        Another popular strategy is to bet on underdogs. Underdogs are teams that have lower odds of
                        winning, but they can often be a good bet if you do your analysis. Remember that betting is a longterm game. Don’t be tempted to bet large sums on a single match; this is a sure-fire way to lose
                        money. Instead, focus on making small bets over some time and building your winnings gradually.
                        <h3> The Benefits of Betting on the PSL</h3>

                        Betting on the live cricket PSL offers several benefits. With the right strategies and research, it’s
                        possible to make a profit when betting on the PSL.
                        In addition, betting on the PSL can be a great way to add excitement to the game. Watching a
                        match can be much more exciting when you have a stake in the outcome, and it can also add an
                        extra layer of strategy to the game.
                        Finally, betting on the PSL can be an amazing way to get to know the teams and players.
                        Researching and learning about the teams and players can help you make more informed decisions
                        when placing your bets.
                        <h2> Final Thoughts</h2>
                        The Pakistan Super League (PSL) is one of the most exciting cricket leagues in the world, with
                        millions of fans from around the globe to watch the thrilling matches. The PSL has had a hugely
                        positive impact on the sport of cricket in Pakistan. The league has provided a platform for young,
                        upcoming players nationwide to showcase their talents and make a name for themselves. This has
                        led to an increase in the popularity of cricket in the nation, with millions of fans tuning in to watch
                        the action every year.
                        The PSL has also had an economic impact on the country, with sponsors and broadcasters investing
                        heavily in the tournament. This influx of money has allowed the PCB to invest in infrastructure
                        and development, leading to a boom in the cricketing industry in Pakistan. So, stay tuned to
                        BetDaily to get all details about Pakistan Super League, like PSL Points Table, to enhance your
                        PSL betting experience.

                    </div>
                </Accordion>
            </AccordionWrapper>
        </>
    )
}

export default BetdailySEO;

const Table = styled.table`
    border-collapse: collapse;
    /* width: 70%; */

    tr, td {
        border-collapse: collapse;
        text-align: center;
        padding: 0 1rem;
    }
`;